import React from 'react';
import MainPage from "../leap";

const SCPage = (props) =>  <MainPage type="sc" {...props}/>;
export default SCPage;
